import { Asterisk } from "lucide-react";

const items = [
  "Automotive",
  "Portrait",
  "Golden Hour",
  "Night Drives",
  "Editorial",
  "Car Meets",
  "Shoreline",
  "Available Light",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-white/10 bg-coal/60 py-4 select-none" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max items-center gap-10">
        {row.map((t, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-serif italic text-2xl text-ash whitespace-nowrap">{t}</span>
            <Asterisk size={18} className="text-flame shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}
